import React from 'react';

import Avatar from 'material-ui/Avatar';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton'

import ActionSearchIcon from 'material-ui/svg-icons/action/search';
import ContentAddIcon from 'material-ui/svg-icons/content/add';
import NavigationMenuIcon from 'material-ui/svg-icons/navigation/menu';


const iBtnStyle = {
  position: 'absolute',
  top: 6,
  minWidth: 60,
  height: 42,
  lineHeight: '42px',
  color: '#fff',
};


export default class MainAppBarInactive extends React.Component {

  click(actionName, payload=null) {
    payload = payload || {};
    const { onAction } = this.props;
    onAction && onAction({...payload, name: 'click', target: actionName});
  }

  render() {
    const { feed } = this.props;
    return (
      <div>
        <FlatButton
          icon={<NavigationMenuIcon />}
          style={{...iBtnStyle, left: 2}}
          title="Show/Hide side bar"
          onTouchTap={e => {this.click('main-app-bar-inactive-side-bar');}}
        />
        <FlatButton
          title={feed.description}
          label={feed.label}
          style={{...iBtnStyle, left: 64}}
          onTouchTap={e => {this.click('main-app-bar-inactive-feed');}}
        />
        <div style={{
          fontSize: '28px',
          margin: '12px 0 0 0',
          display: 'inline-block',
          color: '#fff',
        }}>STASH</div>

        <FlatButton
          style={{...iBtnStyle, right: 150, width: 60}}
          icon={<ActionSearchIcon />}
          title="Search the feed"
          onTouchTap={e => {this.click('main-app-bar-inactive-search');}}
        />
        <FlatButton
          icon={<ContentAddIcon />}
          style={{...iBtnStyle, right: 68, width: 74}}
          backgroundColor="#FF3368"
          hoverColor="#FF3368"
          title="Add new molecule"
          onTouchTap={e => {this.click('main-app-bar-inactive-add-new');}}
        />
        <IconMenu
          style={{
            position: 'absolute',
            top: 3,
            right: 2,
          }}
          iconButtonElement={
            <IconButton
              style={{padding: 0, width: 60}}
              onTouchTap={e => {this.click('main-app-bar-inactive-avatar');}}
            >
              <Avatar
                color="#1AC6FF"
                backgroundColor="#f1f1f1"
                size="36"
              >
                <span style={{
                  marginTop: 3,
                  display: 'inline-block',
                  margin: 'auto',
                  fontSize: '16px',
                  lineHeight: '38px',
                }}>BR</span>
              </Avatar>
            </IconButton>
          }
          anchorOrigin={{horizontal: 'right', vertical: 'top'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
        >
          <MenuItem
            value="refresh"
            primaryText="Refresh"
            onTouchTap={e => {this.click('main-app-bar-inactive-refresh');}}
          />
          <MenuItem
            value="profile"
            primaryText="Profile"
            onTouchTap={e => {this.click('main-app-bar-inactive-profile');}}
          />
          <MenuItem
            value="signout"
            primaryText="Sign out"
            onTouchTap={e => {this.click('main-app-bar-inactive-signout');}}
          />
        </IconMenu>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MainAppBar/MainAppBarInactive.jsx